import React from 'react'

// HOC
import DefaultlayoutHoc from "../layout/Default.layout";

const PlayPage = () => {
  return (
    <div>PlayPage</div>
  )
}

export default DefaultlayoutHoc(PlayPage)